import React from 'react';
import {View} from 'react-native';
import AVText from 'src/components/elements/AVText';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import AccountStore from 'src/stores/AccountStore';
import Util from 'src/Util';
import {TransactionDetail} from 'src/types/TransactionDetail';
import {ListScanItemsProps} from 'src/components/screens/scanAndPay/listScanItems/ListScanItems';
import {getDescriber} from 'src/components/screens/orderAhead/descriptor/DescriptorType';

const {depositStyles} = getDescriber();

export interface DepositProps {
  transaction: TransactionDetail | null;
  listProps: ListScanItemsProps;
}

export const Deposit: React.FC<DepositProps> = ({transaction, listProps}) => {
  if (!transaction) return null;

  const deposit = parseFloat(transaction.Deposit ?? '0');

  if (deposit <= 0) return null;

  const formatted = Util.formatCurrency(
    listProps,
    deposit,
    AccountStore.getCurrency(),
  );

  return (
    <View style={depositStyles().depositView}>
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
        accessible={true}
        accessibilityRole="text"
        accessibilityLabel={Localized.Labels.deposit}
        aria-label={Localized.Labels.deposit}
        style={depositStyles().transactionItemsDeposit}
      >
        {Localized.Labels.deposit}
      </AVText>
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
        accessible={true}
        accessibilityRole="text"
        accessibilityLabel={[Localized.Labels.deposit, formatted].join(' ')}
        aria-label={[Localized.Labels.deposit, formatted].join(' ')}
        style={depositStyles().transactionItemsDeposit}
      >
        {formatted}
      </AVText>
    </View>
  );
};

